import React, { useCallback, useMemo, useState } from "react";
import { useLazyQuery } from "@apollo/react-hooks";
import { Breadcrumb, message } from "antd";
import gql from "fraql";
import { get } from "lodash";
import ReportTableDisplayResults from "../utils/ReportTableDisplayResults";
import LayoutPageHeader from "../../LayoutPageHeader";
import ReportDataExportButton from "../ReportDataExportButton";
import TeamDetailReportForm from "./TeamDetailReportForm";
import "../SummaryReportPage.scss";

const GET_TEAM_DETAIL_REPORT = gql`
  query TeamDetailReportPage_GetTeamDetailReport($CompetitionIds: [ID!]!) {
    TeamDetailReport(competitionIds: $CompetitionIds) {
      result
    }
  }
`;

function TeamDetailReportPage() {
  const [getReport, { loading, data, error }] = useLazyQuery(GET_TEAM_DETAIL_REPORT, {
    onError: err => {
      console.error(err);
      message.error("Failed to generate the report.");
    },
  });

  const reportData = useMemo(() => get(data, "TeamDetailReport.result", null), [data]);

  const tableColumns = [
    { title: "Sport", dataIndex: "SportName", key: "SportName" },
    { title: "Competition", dataIndex: "CompetitionName", key: "CompetitionName" },
    { title: "Age group", dataIndex: "AgeGroup", key: "AgeGroup" },
    { title: "Team", dataIndex: "TeamName", key: "TeamName" },
    { title: "Team Manager", dataIndex: "TeamManager", key: "TeamManager" },
    { title: "Id", dataIndex: "PersonId", key: "PersonId" },
    { title: "First name", dataIndex: "FirstName", key: "FirstName" },
    { title: "Last name", dataIndex: "LastName", key: "LastName" },
    { title: "Age", dataIndex: "Age", key: "Age" },
    { title: "Gender", dataIndex: "Gender", key: "Gender" },
  ];

  const handleSubmitForm = useCallback(
    async (values, actions) => {
      const { CompetitionIds } = values;
      getReport({ variables: { CompetitionIds } });
      actions.setSubmitting(false);
    },
    [getReport],
  );

  const [filteredRows, setFilteredRows] = useState([]);
    const filteredRowKeys = useMemo(() => {
      return filteredRows.map(row => row.key);
    }, [filteredRows]);

  let actions;

  if (reportData) {
    actions = (
      <>
        <ReportDataExportButton
          title="Team Detail Report"
          data={{ rows: reportData, columns: tableColumns.map(column => column.dataIndex) }}
          selectedRowKeys={filteredRowKeys}
          disabled={loading}
        />
      </>
    );
  } else {
    actions = null;
  }

  return (
    <>
      <div
        style={{
          borderBottom: "2px solid #e8e8e8",
          padding: "15px 24px",
        }}
      >
        <Breadcrumb style={{ marginBottom: 10 }}>
          <Breadcrumb.Item>Reports</Breadcrumb.Item>
          <Breadcrumb.Item>TeamDetailReportPage Report</Breadcrumb.Item>
        </Breadcrumb>

        <LayoutPageHeader title="Team Detail Report" extra={actions} />
      </div>

      <div className="summary-report__container">
        <div className="summary-report__flex-container">
          <div className="summary-report__left-sidebar">
            <div className="summary-report__left-sidebar-content">
              <TeamDetailReportForm handleSubmit={handleSubmitForm} />
            </div>
          </div>
          <div className="summary-report__content">
            <ReportTableDisplayResults data={reportData} loading={loading} error={error} columns={tableColumns} setFilteredRows={setFilteredRows} />
          </div>
        </div>
      </div>
    </>
  );
}

export default TeamDetailReportPage;
